import React from 'react';
import axios from 'axios';

import { formatDateTime } from '../../Utils/GlobalUtils';

import Loading from '../Loading';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import styles from '../../styles/Settings.module.css';

export default function InformationMessage({ userRole }) {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        type: 'warning',
        message: '',
        addressee: 'Все',
        is_active: false,
        created_at: '',
    });
    const [isFirst, setIsFirst] = React.useState(false);

    const [loading, setLoading] = React.useState(true);
    const [status, setStatus] = React.useState('');
    const [reload, setReload] = React.useState(true);

    React.useEffect(() => {
        axios.get('/api/get-info-message')
        .then((response) => {
            if (!response.data || !response.data.created_at || response.data.message.trim() === '') {
                setIsFirst(true);
            } else {
                setFormInfo(response.data);
            }
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload]);

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
    const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.message) {
            newErrors.message = 'Обязательное поле';
        }
        if (formInfo.message && (formInfo.message.length < 2 || formInfo.message.length > 500)) {
            newErrors.message = 'Значение не может быть меньше 2 и более 500 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };
    
    const addNewInfoMessage = () => {
        const token = localStorage.getItem('token');

        axios.post(`/api/add-new-info-message`, { 
            type: formInfo.type,
            message: formInfo.message.trim(), 
            addressee: formInfo.addressee,
            is_active: formInfo.is_active,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then(() => {
            openTimeModal(`Сообщение создано`, 'success');
            setStatus(null);
            setReload(true);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
    }

    const changeInfoMessage = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-info-message`, {
            id: formInfo.id, 
            type: formInfo.type,
            message: formInfo.message.trim(), 
            addressee: formInfo.addressee,
            is_active: formInfo.is_active,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then(() => {
            openTimeModal(`Информация обновлена. Изменения уже вступили в силу`, 'success');
            setStatus(null);
            setReload(true);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (isFirst) {
                addNewInfoMessage();
            } else {
                changeInfoMessage();
            }
        }
        setLoading(false);
    }

    return (
        <>
        <div className={styles.openSectionHeader}>
            <h3>Информационное сообщение</h3>
            {loading && <Loading type='inline' />}
        </div>
        <div className={styles.openSectionMain}>
            {userRole=='АппаратСРО' ? 
            <>
                <a>Выберите тип сообщения</a>
                <div className='radioSwitchWrapper'>
                    <label className={`radioSwitchLabel ${formInfo.type === 'warning' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='warning'
                            checked={formInfo.type === 'warning'}
                            onChange={handleChange('type')}
                        />
                        <span>Предупреждение</span>
                    </label>
                    <label className={`radioSwitchLabel ${formInfo.type === 'error' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='error'
                            checked={formInfo.type === 'error'}
                            onChange={handleChange('type')}
                        />
                        <span>Ошибка</span>
                    </label>
                </div>
                <a>Введите информационное сообщение</a>
                <div className='inputWrapper'>
                <textarea 
                    cols='10' 
                    rows='10' 
                    value={formInfo.message}  
                    className={errorsForm.message ? 'inputError' : ''}
                    onChange={handleChange('message')}
                    minLength='' 
                    maxLength='500' 
                    disabled={loading}
                    required
                >
                </textarea>
                <p className='description'>{formInfo.message.length}/500</p>
                {errorsForm.message && <div className='errorUnderInput'>{errorsForm.message}</div>}
                </div>
                {/* <a>Выберите адресатов</a>
                <div className='radioSwitchWrapper'>
                    <label className={`radioSwitchLabel ${formInfo.addressee === 'Арбитражный управляющий' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='Арбитражный управляющий'
                            checked={formInfo.addressee === 'Арбитражный управляющий'}
                            onChange={handleChange('addressee')}
                        />
                        <span>Управляющим</span>
                    </label>
                    <label className={`radioSwitchLabel ${formInfo.addressee === 'АппаратСРО' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='АппаратСРО'
                            checked={formInfo.addressee === 'АппаратСРО'}
                            onChange={handleChange('addressee')}
                        />
                        <span>Аппарату СРО</span>
                    </label>
                    <label className={`radioSwitchLabel ${formInfo.addressee === 'Все' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='Все'
                            checked={formInfo.addressee === 'Все'}
                            onChange={handleChange('addressee')}
                        />
                        <span>Всем</span>
                    </label>
                </div> */}
                {/* {!loading &&
                <div>
                    <p className='description'>Последнее сообщение сохранено {formatDateTime(formInfo.created_at)}</p>
                </div>} */}
                <div className={styles.settingLine} style={{margin: '15px 0'}}>
                    <a className={styles.settingLabel}>Отображать сообщение</a>
                    <div className='checkboxWrapper'>
                        <label className='switch' htmlFor='is_active'>
                            <input type='checkbox' id='is_active' checked={formInfo.is_active} onChange={handleChange('is_active')} />
                            <div className='slider round'></div>
                        </label>
                    </div>
                </div>
                <div>
                </div>
                <div className='panelFormConfirmation'>
                    <div>{status && status}</div>
                    <button 
                        className='button black' 
                        onClick={handleSave}
                        disabled={loading}
                    >
                        Применить изменения
                    </button>
                </div>
            </>
            : <a>У вашей учётной записи недостаточный доступ на просмотр содержимого</a>}
        </div>
        </>
    )
}
